import React from 'react';
import Title from '../Title';
import { ComplementaryServiceCategoryState } from '../../../../types/properties/propertyTypes';
import useTranslate from '../../../../customHooks/useTranslate';

interface ServiceMenuProps {
    titleServices: string;
    onItemClick: (idCategory: number) => void;
    idSelectedMenuItem: number;
    optionsCategories: ComplementaryServiceCategoryState[];
}

const ServiceMenu = (props: ServiceMenuProps) => {
    const {
        titleServices,
        onItemClick,
        idSelectedMenuItem,
        optionsCategories,
    } = props;
    const translate = useTranslate();

    return (
        <nav className='service__menu-container'>
            <Title
                text={'categories'}
                translated={true}
                className='text-secondary-color'
            />
            <ul className='service__menu-list'>
                <li
                    className={`service__menu-item${
                        idSelectedMenuItem === 0
                            ? ' service__menu-item--selected'
                            : ''
                    }`}
                    onClick={() => onItemClick(0)}
                >
                    {translate(titleServices)}
                </li>
                {optionsCategories.map(category => (
                    <li
                        key={category.id}
                        className={`service__menu-item${
                            idSelectedMenuItem === parseInt(category.id)
                                ? ' service__menu-item--selected'
                                : ''
                        }`}
                        onClick={() => onItemClick(parseInt(category.id))}
                    >
                        {category.name}
                    </li>
                ))}
            </ul>
        </nav>
    );
};

export default ServiceMenu;
